<template>
  <div class="trainers">
    <div class="trainers__content">
      <responsive>
        <table class="table">
          <thead>
            <th style="min-width: 60px">ID</th>
            <th style="min-width: 200px">Trainer name</th>
            <th style="min-width: 200px">Nickname</th>
            <th style="min-width: 300px">E-mail</th>
            <th></th>
          </thead>

          <tbody>
            <tr v-for="(trainer, index) in trainers" :key="index">
              <td>{{ trainer.id }}</td>
              <td>{{ `${trainer.firstName} ${trainer.lastName}` }}</td>
              <td>{{ trainer.nickname }}</td>
              <td>{{ trainer.user ? trainer.user.email : '' }}</td>
              <th>
                <v-button
                  :to="`/admin/trainers/edit/${trainer.id}`"
                  size="small"
                  :disabled="disabled">Edit</v-button>
                <v-button
                  color="danger"
                  size="small"
                  :disabled="disabled"
                  @click.native="removeTrainer(trainer.id)">Remove</v-button>
              </th>
            </tr>
          </tbody>
        </table>
      </responsive>

      <paginate
        :page-count="totalPages"
        :click-handler="handlePaginate"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :container-class="'pagination'"
        :page-class="'pagination__item'">
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import Responsive from '@/components/Responsive'
import VButton from '@/components/Forms/VButton'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'allTrainers',
  data: () => ({
    disabled: false
  }),
  computed: {
    ...mapGetters({
      trainers: 'trainers/allTrainers',
      totalPages: 'trainers/totalPages'
    })
  },
  methods: {
    async removeTrainer (id) {
      const optionsModal = {
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove the trainer!'
      }

      const confirmModal = await this.$swal(optionsModal)

      if (confirmModal.value) {
        this.disabled = true

        await this.remove(id)

        this.disabled = false

        this.$swal(
          'Deleted!',
          'The trainer has been removed.',
          'success'
        )
      }
    },
    handlePaginate (page) {
      this.getAll(page - 1)
    },
    ...mapActions({
      getAll: 'trainers/getAllTrainers',
      remove: 'trainers/removeTrainer',
      clearAllTrainers: 'trainers/clearAllTrainers'
    })
  },
  mounted () {
    this.getAll(0)
  },
  beforeDestroy () {
    this.clearAllTrainers()
  },
  components: {
    Paginate,
    Responsive,
    VButton
  }
}
</script>

<style lang="stylus" scoped>
  // @import '../../components/Table/table.styl'
  // @import '../../components/Pagination/pagination.styl'

  .trainers
    display flex
    flex-flow row wrap

    &__content
      background #fff
      box-shadow 0 2px 6px 0 rgba(0,0,0,0.2)
      max-width 100%
      width 100%
</style>



// WEBPACK FOOTER //
// All.vue?7712bcf0